module.exports = " <div v-el:offset-root class=\"row collapse\"> <div class=\"small-12 medium-2 large-1 columns date\"> <race-list-date-label :date=date></race-list-date-label> </div> <div class=\"small-12 medium-10 large-11 columns loader\"> <race :race=firstRace></race> </div> </div> <div class=\"row collapse\" v-for=\"race in otherRaces\"> <div class=\"small-12 medium-10 medium-offset-2 large-11 large-offset-1 columns loader\"> <race :race=race></race> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/race-schedule/components/RaceListDate.vue
 ** module id = 424
 ** module chunks = 1
 **/